<template>
    <div>
        <div class="vx-row ml-2 mr-2 mb-base">
            <a-select
                size="large"
                class="mt-2 w-full"
                show-search
                :value="optionSearchValue"
                placeholder="Digite a descrição de uma opção"
                style="width: 100%"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                @search="comboOptionSearch"
                @change="addProductOption"
                @blur="optionSearchResult = [...optionData]"
            >
                <template v-slot:notFoundContent>
                    Nenhuma opção encontrada
                </template>
                
                <a-select-option v-for="d in optionSearchResult" :key="d.value">
                    {{ d.text }} <span style="font-size: 10px" v-if="d.alias"> ({{ d.alias }}) </span> 
                </a-select-option>


                <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 4px 0;" />
                    <div style="padding: 4px 8px; cursor: pointer;"  @click="showModalAddOption()" >
                        <a-icon type="plus"/> Incluir Opção 
                    </div>
                </div>
            </a-select>
        </div>
        
        <template v-if="Object.keys(product).length > 0">
            <div class="vx-row ml-2 mr-2 mb-4" v-if="Object.keys(product.options).length">
                <draggable :list="product.options" class="cursor-move w-full" :scroll-sensitivity="200">
                    <transition-group>
                        <div v-for="(option, iOption) in product.options" :key="iOption + 0" style="position: relative">
                            <div class="w-full bg-grey-light-super border border-dashed border-grey-light rounded pl-4 pt-4 pr-4 mb-6 list-item" v-if="option.id != 'size'">
                            
                                <vs-button size="small" radius class="btn-remove-product-option" color="danger" type="gradient" icon-pack="feather" icon="icon-trash" @click="removeOption(option.id)"></vs-button>
                                <div class="vx-row">
                                    <div class="vx-row w-full pl-4" >
                                        <a-button type="dashed" class=" ml-4 cursor-pointer h-10" @click="editOption(option)">
                                            <a-icon type="edit" /> 
                                        </a-button>

                                        <div class="w-5/12 ml-3" @click="() => option.showItems = !option.showItems">
                                            <h4 class="w-full text-primary truncate"> {{ option.description.toUpperCase() }} </h4>
                                            <span class="w-full text-sm truncate" style="position: relative; top: -12px"> {{ (option.alias || '').toUpperCase() }} &nbsp; </span>
                                        </div>
                                        <span @click="() => option.showItems = !option.showItems" class="w-2/12 font-bold text-sm mt-1 text-primary truncate"> MIN: {{ option.min }} </span>
                                        <span @click="() => option.showItems = !option.showItems" class="w-2/12 font-bold text-sm mt-1 text-primary truncate"> MAX: {{ option.max }} </span>

                                        <div @click="() => option.showItems = !option.showItems" class="w-1/12 text-right cursor-pointer">
                                            <a-icon type="arrow-down" v-if="option.showItems" />
                                            <a-icon type="arrow-left" v-else />
                                        </div>
                                    </div>

                                    <vs-table class="w-full" :data="option.items" :thead="null" stripe v-if="option.showItems">
                                        <template slot="thead">
                                            <!-- <vs-th style="width: 1%">Ativo</vs-th> -->
                                            <vs-th style="width: 50%" class="truncate">Descrição.</vs-th>
                                            <vs-th style="width: 10%">Min.</vs-th>
                                            <vs-th style="width: 10%">Máx.</vs-th>
                                            <vs-th style="width: 25%">Preço</vs-th>
                                        </template>

                                        <template class="w-full" slot-scope="{data}">
                                            <vs-tr v-for="(item, iItem) in data" :key="iItem">
                                                <!-- <vs-td class="align-left"> <vs-checkbox color="danger" v-model="item.active"></vs-checkbox> </vs-td> -->
                                                <vs-td> {{ item.description }} </vs-td>
                                                <vs-td> {{ item.min }} </vs-td>
                                                <vs-td> {{ item.max }} </vs-td>
                                                <vs-td> {{ item.value | currency }} </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </template>

        <option-add-edit 
            :visible="modalOption.visible"
            :data="modalOption.optionData"
            @saved="(option) => saveOptionToComboSearch(option, true)"
            @close="val => closedModalAddOption(val)"
        />
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import draggable from 'vuedraggable'
    import OptionAddEdit from '../productOptions/OptionsAddEdit'
    import { mapState, mapMutations } from 'vuex'

    const ref = firebase.firestore()

    export default {
        components: {
            draggable,
            OptionAddEdit,
            VNodes: {
                functional: true,
                render: (h, ctx) => ctx.props.vnodes,
            },
        },

        data () {
            return {
                optionData  : [],
                optionSearchResult : [],
                optionSearchValue : undefined,
                companyId : this.$store.getters.getCompanyID,
                product : {},
                modalOption : {
                    optionData : {},
                    visible : false
                }
            }
        },

        created () {
            this.getOptionsData()
        },

        async mounted () {
            this.convertOptionsDataToArray(Object.assign({}, this.productInfo))
        },

        watch : {
            product : {
                deep : true,
                handler (val) {
                    this.product.options.forEach((option, i) => {
                        if(option.id == 'size') 
                            option.order = 0
                        else {
                            option.order = i++
                        }
                    })
                    this.emitUpdateOptionData()
                }
            }
        },

        computed : {
            ...mapState('product', ['productInfo'])
        },

        methods : {
            showModalAddOption () {
                this.modalOption.visible = true
            },

            closedModalAddOption (val) {
                this.modalOption.optionData = {}
                this.modalOption.visible = val
            },
            
            async getOptionsData () {
                let options = await ref.collection(`/company/${this.companyId}/productOptions/`).get()

                options.forEach(option => {
                    this.saveOptionToComboSearch(option.data())
                })
            },

            saveOptionToComboSearch (option, addToProduct = false) {
                let obj = { id: option.id, value: option.id, text: option.description, showItems : false, ...option }

                let alreadyInOption = this.optionData.findIndex(a => a.id == option.id)
                if(alreadyInOption >= 0)
                    this.$set(this.optionData, alreadyInOption, obj);
                else
                    this.optionData.push(obj)
                   
                let alreadyInCombo = this.optionSearchResult.findIndex(a => a.id == option.id)
                if(alreadyInCombo >= 0)
                    this.$set(this.optionSearchResult, alreadyInCombo, obj);
                else
                    this.optionSearchResult.push(obj)

                if(addToProduct) {
                    this.addProductOption(option.id)
                }
            },

            comboOptionSearch (value) {
                this.optionSearchResult = [...this.optionData]
                if(!value.length) return
                
                this.optionSearchResult = [...this.optionData.filter(a => a.text.toUpperCase().trim().search(value.trim().toUpperCase()) != -1)]
            },

            addProductOption (selectedOptionID) {
                let obj = this.optionData.find(a => a.id == selectedOptionID)

                if(!Object.keys(this.product.options).length)
                    this.product.options = [] 
                
                let alreadyInProduct = this.product.options.findIndex(a => a.id == selectedOptionID)
                if(alreadyInProduct == -1)
                    this.product.options.push({
                        id : selectedOptionID,
                        ...obj
                    })
                else
                    this.$set(this.product.options, alreadyInProduct, obj)
            },

            editOption (option) {
                this.modalOption = { visible : true, optionData : option }
            },

            removeOption (optionId) {
                this.product.options.forEach((option, i) => {
                    if (option.id == optionId){
                        this.product.options.splice(i, 1)
                    }
                })

                this.emitUpdateOptionData()
            },

            convertOptionsDataToArray (product) {
                let newOptions = []
                Object.entries(product.options).forEach((option, i) => {
                    newOptions[i] = {...option[1]}
                    this.$set(newOptions[i], 'showItems', false)
                })

                product.options = newOptions.sort((a, b) => a.order - b.order)
                this.product = product
            },

            convertOptionsDataToObject() {
                let newOptions = {}

                this.product.options.forEach((option, i) => {
                    newOptions[option.id] = Object.assign({}, option)
                    delete newOptions[option.id].value
                    delete newOptions[option.id].text
                    delete newOptions[option.id].showItems
                })

                return newOptions
            },

            emitUpdateOptionData () {
                let options = {...this.convertOptionsDataToObject()}
                // this.$emit('change', options)
                this.setProductOption(options)

            },

            ...mapMutations('product', ['setProductOption'])
        }
    }
</script>

<style>
    .btn-remove-product-option {
        position: absolute;

        top: -15px; 
        left: 97%;
    }

    .list-item { transition: all .2s }
</style>